import { DndComponentClass } from "react-dnd";

export function FixDnd<Props>(C: React.ComponentType<Props>) {
  return C as React.ComponentType<Props> & DndComponentClass<Props>
}



// WEBPACK FOOTER //
// ./src/view/DragAndDrop.tsx